var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1237_22391)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6848 61.3823H10.3152C4.61277 61.3823 0 56.7695 0 51.0671V10.896C0 5.22996 4.61277 0.617188 10.3152 0.617188H51.6848C57.3509 0.617188 61.9637 5.22996 61.9637 10.896V51.0671C61.9637 56.7695 57.3509 61.3823 51.6848 61.3823Z",
    fill: "#DBE3F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9638 30.4007V51.0674C61.9638 54.2273 60.5836 57.024 58.3317 58.9127L31.0546 33.9602C30.3281 34.1781 29.7833 33.2701 30.3645 32.7253L41.3697 22.5554C44.8202 19.3591 50.2321 19.5407 53.9731 22.9912L61.9638 30.4007Z",
    fill: "#C7D1E4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1003 19.9038C20.5578 19.9038 18.4512 17.7972 18.4512 15.2184C18.4512 12.676 20.5578 10.5693 23.1003 10.5693C25.6791 10.5693 27.7494 12.676 27.7494 15.2184C27.7494 17.7972 25.6791 19.9038 23.1003 19.9038Z",
    fill: "#7D8FB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6848 61.3826H10.3152C4.61277 61.3826 0 56.7698 0 51.0674V44.457L15.9449 29.7106C19.3954 26.5144 24.8073 26.696 28.5483 30.1465L58.9854 58.3316C57.133 60.2203 54.5542 61.3826 51.6848 61.3826Z",
    fill: "#7D8FB3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1237_22391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/fileUpload.46ef364f148bde5f20700070f1e61600.svg";
export { ForwardRef as ReactComponent };